import { render, staticRenderFns } from "./settlement-agreement.vue?vue&type=template&id=9e260bce&scoped=true"
import script from "./settlement-agreement.vue?vue&type=script&lang=js"
export * from "./settlement-agreement.vue?vue&type=script&lang=js"
import style0 from "./settlement-agreement.vue?vue&type=style&index=0&id=9e260bce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e260bce",
  null
  
)

export default component.exports